import mediator from "@tvg/mediator";

export const onSelectProviderGtmEvent = (module) =>
  mediator.base.dispatch({
    type: "REGISTRATION:TVG_PROVIDER_SELECT_PROVIDER",
    payload: {
      module
    }
  });

export const onAppliesProviderGtmEvent = (providerName, module) =>
  mediator.base.dispatch({
    type: "REGISTRATION:TVG_PROVIDER_APPLIED_PROVIDER",
    payload: {
      providerName,
      module
    }
  });

export const onRemoveProviderGtmEvent = (module) =>
  mediator.base.dispatch({
    type: "REGISTRATION:TVG_PROVIDER_REMOVE_PROVIDER",
    payload: {
      module
    }
  });

export const onCloseProviderModalGtmEvent = () =>
  mediator.base.dispatch({
    type: "REGISTRATION:TVG_PROVIDER_CLOSE_MODAL"
  });
